import { json2xml } from './json2xml';
import { stringifyOpenAPI } from './stringifyOpenAPI';
import { t } from './translate';
/**
 * Display an example.
 */
export function OpenAPIExample(props) {
    var example = props.example, context = props.context, syntax = props.syntax;
    var code = stringifyExample({ example: example, xml: syntax === 'xml' });
    if (code === null) {
        return <OpenAPIEmptyExample context={context}/>;
    }
    return context.renderCodeBlock({ code: code, syntax: syntax });
}
function stringifyExample(args) {
    var example = args.example, xml = args.xml;
    if (!example.value) {
        return null;
    }
    if (typeof example.value === 'string') {
        return example.value;
    }
    if (xml) {
        return json2xml(example.value);
    }
    return stringifyOpenAPI(example.value, null, 2);
}
/**
 * Empty response example.
 */
export function OpenAPIEmptyExample(props) {
    var context = props.context;
    return (<pre className="openapi-example-empty">
            <p>{t(context.translation, 'no_content')}</p>
        </pre>);
}
